const Promise = require('bluebird')
const Axios = require('axios-https-proxy-fix')
const useragentFromSeed = require('useragent-from-seed')
const _ = require('underscore')
const tunnel = require('tunnel');
const getPostData = async (shortcode) => {

  try {



    let baseUrl = 'https://instagram.com'
    let setHeaders = {

      'Accept-Language': 'en',
      "Access-Control-Allow-Origin": "*",
      'X-Requested-With': 'XMLHttpRequest',

      Referer: baseUrl
    }
    setHeaders['User-Agent'] = await useragentFromSeed(shortcode)
    setHeaders['Content-Type'] = 'application/x-www-form-urlencoded'

    const proxy = [{
      host: '35.222.168.81',
      port: '3128',
      auth: {
        username: 'ts_proxy',
        password: 'tapspree20'
      }
    }, {
      host: '35.192.66.91',
      port: '3128',
      auth: {
        username: 'ts_proxy',
        password: 'tapspree20'
      }
    }]


    //http://ts_proxy:tapspree20@35.222.168.81:3128

    const finalProxy = _.shuffle(proxy)[0];

    //console.log("HEADERS: ", setHeaders)
    //console.log("FINAL PROXY: ", finalProxy)
    //console.log(`POST URL: https://www.instagram.com/p/${shortcode}`)
    //await Axios.create(agent)
    let body = await Axios.get(`https://www.instagram.com/p/${shortcode}`, {
      proxy: finalProxy
    }, {
      headers: setHeaders
    })
    let dataExp = /window\._sharedData\s?=\s?({.+);<\/script>/;

    //console.log("BODY DATA: ", body)
    let dataString = body.data.match(dataExp)[1];
    //console.log("DATA STRING:", dataString)
    let postRaw = JSON.parse(dataString);

    //console.log("POST RAW:", postRaw)

    //console.log("HERE IS THE BODY: ", JSON.stringify(profileRaw.entry_data.ProfilePage[0].graphql))


    let postData = postRaw.entry_data.PostPage[0].graphql

    //console.log("HERE IS THE POST DATA: ", postData)

    let thisPost = {}
    thisPost.profileName = postData.shortcode_media.owner.username
    thisPost.profileId = postData.shortcode_media.owner.id
    thisPost.mediaId = postData.shortcode_media.id
    thisPost.shortcode = postData.shortcode_media.shortcode
    thisPost.displayUrl = postData.shortcode_media.display_url
    thisPost.isVideo = postData.shortcode_media.is_video

    if (postData.shortcode_media.__typename == 'GraphSidecar') {
      thisPost.mediaType = "carousel"
      thisPost.carouselMedia = postData.shortcode_media.edge_sidecar_to_children
    }
    if (postData.shortcode_media.__typename == 'GraphVideo') {
      thisPost.mediaType = "video"
      thisPost.videoUrl = postData.shortcode_media.video_url
      thisPost.viewCount = postData.shortcode_media.video_view_count
    }
    if (postData.shortcode_media.__typename == 'GraphImage') {
      thisPost.mediaType = "image"
    }

    let hashtagString
    try {
      if (postData.shortcode_media.edge_media_to_parent_comment.page_info.has_next_page === true) {
        thisPost.commentPaging = true
        thisPost.commentToken = postData.shortcode_media.edge_media_to_parent_comment.page_info.end_cursor
      }
    } catch (e) {
      console.log("THERE WAS AN ERROR: ", e)
    }
    let commentList = postData.shortcode_media.edge_media_to_parent_comment.edges
    thisPost.commentList = commentList

    if (commentList.length > 0) {
      console.log("COMMENTS EXIST...")
      if (commentList[0].node.owner.username == postData.shortcode_media.owner.username) {
        console.log("OWNER COMMENT...")
        hashtagString = commentList[0].node.text
      }
    }
    try {
      thisPost.location = postData.shortcode_media.location.name
    } catch (e) {
      thisPost.location = ''
    }
    try {
      thisPost.caption = postData.shortcode_media.edge_media_to_caption.edges[0].node.text

    } catch (e) {
      thisPost.caption = ''
    }
    try {
      hashtagString = `${hashtagString} ${thisPost.caption}`
      //console.log("HASHTAG STRING:", hashtagString)
      thisPost.hashtags = await extractHashtags(hashtagString)
      //console.log("HASHTAGS:", thisPost.hashtags)

    } catch (err) {
      console.log("THERE WAS AN ERROR:", err)
    }

    thisPost.commentCount = postData.shortcode_media.edge_media_to_parent_comment.count
    thisPost.likeCount = postData.shortcode_media.edge_media_preview_like.count
    thisPost.takenAt = postData.shortcode_media.taken_at_timestamp
    return {
      success: true,
      result: thisPost
    }

  } catch (e) {
    return {
      success: false,
      message: e
    }
  }

}

const extractHashtags = async (searchText) => {

  try {
    var regexp = /\B\#\w\w+\b/g
    let result = searchText.match(regexp);
    if (result) {
      return Promise.map(result, function (s) {
        s = s.slice(1).toLowerCase()
        //resolve( s.trim())
        return s.trim()
      })
    } else {
      return []
    }
  } catch (err) {
    console.log("THERE WAS AN ERROR:", err)
    return []
  }

}

module.exports = {
  getPostData,
  extractHashtags
}